/**
 * Copy URL to clipboard.
 * @param {HTMLElement} el Element which is clicked copy URL to clipboard.
 */
const copyToClipboard = (el) => {
  if (!el) {
    return;
  }

  if (el.classList.contains( 'copy-url--successful' )) {
    el.classList.remove( 'copy-url--successful' );
  }

  const url = window.location.href;

  navigator.clipboard.writeText( url )
    .then( () => {
      el.classList.add( 'copy-url--successful' );
      setTimeout( () => el.classList.remove( 'copy-url--successful' ), 1500 );
    } )
    .catch( () => {
      // Fallback if browser doesn't support .execCommand('copy')
      if (navigator.platform.toLowerCase().startsWith( 'mac' )) {
        window.prompt( "Copy to clipboard: Command+C, Enter", url );
      } else {
        window.prompt( "Copy to clipboard: Ctrl+C, Enter", url );
      }
    } );
};

export default copyToClipboard
